/**
 * Page Referrer State (Valtio)
 *
 * Tracks the previous and current page URL for GTM page_referrer field.
 * Updated on each client-side navigation by GoogleAnalyticsProvider.
 */

import { proxy } from 'valtio';

interface PageReferrerState {
  currentUrl: string;
  previousUrl: string;
}

export const pageReferrerState = proxy<PageReferrerState>({
  currentUrl: globalThis.window === undefined ? '' : globalThis.window.location.href,
  previousUrl: globalThis.document === undefined ? '' : globalThis.document.referrer,
});

export const pageReferrerActions = {
  /**
   * Update on navigation: current becomes previous, new URL becomes current.
   */
  navigate(newUrl: string): void {
    pageReferrerState.previousUrl = pageReferrerState.currentUrl;
    pageReferrerState.currentUrl = newUrl;
  },
};
